import React, { createContext, useContext, useState, useEffect } from 'react';
import { THEMES, THEME_KEY } from '../constants/theme';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // Read initial theme from documentElement class list (pre-applied by blocker script)
  const getInitialTheme = () => {
    if (typeof window !== 'undefined' && window.localStorage) {
      const stored = window.localStorage.getItem(THEME_KEY);
      if (stored === THEMES.LIGHT || stored === THEMES.DARK) {
        return stored;
      }
    }
    // If not found in localStorage, fallback to already applied class from documentElement
    if (document.documentElement.classList.contains(THEMES.DARK)) {
      return THEMES.DARK;
    }
    return THEMES.LIGHT;
  };

  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    const root = document.documentElement;
    if (theme === THEMES.LIGHT) {
      root.classList.remove(THEMES.DARK);
      root.classList.add(THEMES.LIGHT);
    } else {
      root.classList.remove(THEMES.LIGHT);
      root.classList.add(THEMES.DARK);
    }
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === THEMES.LIGHT ? THEMES.DARK : THEMES.LIGHT));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
